import { render, staticRenderFns } from "./VinculosGrupoTurma.vue?vue&type=template&id=54083b47&"
import script from "./VinculosGrupoTurma.vue?vue&type=script&lang=js&"
export * from "./VinculosGrupoTurma.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports